import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Create,
} from "adminApi/TaxManagementApi/TaxManagement";
import fields from "../json/TaxListFeilds.json";
import { validateForm } from "utils/validation";
import { TaxManagementRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditTaxManagementForm from "./Componates/AddTaxManagementForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddTaxManagement = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange} = useFormChange(initialValues, TaxManagementRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({data:formData});
    },
    (vals) => validateForm(vals, TaxManagementRules),
    () =>{ 
      return navigate(-1)
    },
    "Tax Created successfully"
  );
  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <EditTaxManagementForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Add Tax"
      />
    </>
  );
};

export default AddTaxManagement;
